export const LOCAL_USER_KEY = "userData";
export const LOCAL_USER_ROLE_KEY = "userRole";
